"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module Routes - initiates the client side routes
 */
// these 2 required old-style require()
var qs = require("querystring");
var page = require("page");
var session_timer_util_1 = require("./utils/timers/session-timer.util");
var route_1 = require("./actions/route");
var ui_1 = require("./actions/ui");
var client_error_logger_1 = require("./utils/logging/client-error-logger");
var constants_1 = require("./constants");
var BASE_URI = constants_1.default.BASE_URI, ROUTES = constants_1.default.ROUTES, PAGES = constants_1.default.PAGES, VIEWS = constants_1.default.VIEWS, FLOWS = constants_1.default.FLOWS;
/**
 * If client route does not define certain route, it will go to server.
 *
 * @param store
 */
function initRoutes(store) {
    function parseQuery(context, next) {
        context.query = qs.parse(context.querystring) || {};
        next();
    }
    // We need 2 named arguments for chaining in page.js and second one is the next function
    function startTimer(context, next) {
        if (context.canonicalPath.includes(BASE_URI) &&
            !context.canonicalPath.includes("logout") &&
            !context.canonicalPath.includes("unsubscribe") &&
            !context.canonicalPath.includes("cookies") &&
            !context.canonicalPath.includes("extend-session")) {
            var state = store.getState(), _a = state.route, _b = (_a === void 0 ? {} : _a).enter, _c = (_b === void 0 ? {} : _b).view, enterView = _c === void 0 ? "" : _c, currentPath = context.canonicalPath.slice((BASE_URI + "/").length);
            session_timer_util_1.default(enterView, currentPath);
        }
        next();
    }
    function triggerFPTI(context, next) {
        if (window && window.PAYPAL && window.PAYPAL.fpti) {
            setTimeout(function () {
                window.PAYPAL.fpti.triggerFPTIImpression();
            }, 200);
        }
        next();
    }
    function handleHashUrl(context, next) {
        var hash = context.hash;
        if (hash == undefined || hash == null || hash == "") {
            next();
        }
    }
    function handleError(error) {
        var _a = store.getState().content, content = _a === void 0 ? {} : _a;
        // Catch unexpected errors and report to server
        if (error.stack || error.message) {
            client_error_logger_1.default.log(store, "/flow/error", "ROUTING_ERROR", "", "", "", error);
            // Switch to client error message to show users
            error = "CLIENT_ERROR";
        }
        store.dispatch(ui_1.updateUI({
            showSpinner: false,
            component: { name: "Component Name here" },
            error: content.errors[error] || error,
        }));
    }
    function closeModal(context, viewName, previouslyOpen) {
        var params = context.params, query = context.query, dispatch = store.dispatch;
        dispatch(route_1.default({
            enter: {
                overpanel: false,
                view: viewName,
                slide: 0,
                params: params,
                query: query,
            },
            exit: {
                overpanel: true,
                view: viewName,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    }
    function openModal(context, viewName) {
        var params = context.params, query = context.query, dispatch = store.dispatch;
        dispatch(route_1.default({
            enter: {
                overpanel: false,
                view: viewName,
                slide: 0,
                params: params,
                query: query,
            },
            exit: {
                overpanel: true,
                view: viewName,
                slide: 1,
                params: params,
                query: query,
            },
        }));
    }
    page.base(BASE_URI);
    page("*", parseQuery, startTimer, triggerFPTI, handleHashUrl);
    // Main account page
    page(ROUTES.ACCOUNT, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: false,
                view: PAGES.ACCOUNT,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    // Main notifications page
    page(ROUTES.NOTIFICATIONS, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: false,
                view: PAGES.NOTIFICATIONS,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    // Main security page
    page(ROUTES.SECURITY, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: false,
                view: PAGES.SECURITY,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    // Seller Tools
    page(ROUTES.SELLER_TOOLS, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: false,
                view: PAGES.SELLER_TOOLS,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    // Main Cookies  page
    page(ROUTES.COOKIES, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: false,
                view: PAGES.COOKIES,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    // Main security page
    page(ROUTES.PAYMENTS, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: false,
                view: PAGES.PAYMENTS,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    // Email routes
    page(ROUTES.EMAILS.ADD, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.EMAILS.ADD,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    page(ROUTES.EMAILS.EDIT + "/:id", function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.EMAILS.EDIT,
                slide: 0,
                params: params,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.EMAILS.EDIT,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    page.exit(ROUTES.EMAILS.EDIT + "/:id", function (context, next) {
        closeModal(context, VIEWS.EMAILS.EDIT, true);
        return next();
    });
    page(ROUTES.PASSPORT.UPDATE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.UPDATE_PASSPORT,
                slide: 0,
                params: params,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.UPDATE_PASSPORT,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    page.exit(ROUTES.PASSPORT.UPDATE, function (context, next) {
        closeModal(context, VIEWS.UPDATE_PASSPORT, true);
        return next();
    });
    page("/flow" + ROUTES.NAME.UPDATE, function (context) {
        var query = context.query, params = context.params;
        var state = store.getState();
        var experiments = state.experiments, account = state.account;
        var factors = experiments.factors;
        var userCiped = account.name.userCiped;
        var viewName = VIEWS.UPDATE_NAME;
        if (factors && factors.show_new_name_change_flow) {
            viewName = VIEWS.NEW_UPDATE_NAME;
        }
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: viewName,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: viewName,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.NAME.UPDATE, function (context, next) {
        var state = store.getState();
        var experiments = state.experiments, account = state.account;
        var factors = experiments.factors;
        var userCiped = account.name.userCiped;
        var viewName = VIEWS.UPDATE_NAME;
        if (factors.show_new_name_change_flow) {
            viewName = VIEWS.NEW_UPDATE_NAME;
        }
        closeModal(context, viewName, true);
        next();
    });
    page("/flow" + ROUTES.NAME.CHANGE_REASON, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.CHANGE_REASON,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.CHANGE_REASON,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.NAME.CHANGE_REASON, function (context, next) {
        closeModal(context, VIEWS.CHANGE_REASON, true);
        next();
    });
    page("/flow" + ROUTES.NAME.UPDATE_SUCCESS, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.changeExit({
            enter: {
                overpanel: true,
                view: VIEWS.UPDATE_NAME_SUCCESS,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.NAME.UPDATE_SUCCESS, function (context, next) {
        closeModal(context, VIEWS.UPDATE_NAME_SUCCESS, true);
        return next();
    });
    page("/flow" + ROUTES.NAME.MINOR_NAME_CHANGE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.MINOR_NAME_CHANGE,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.MINOR_NAME_CHANGE,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.NAME.MINOR_NAME_CHANGE, function (context, next) {
        closeModal(context, VIEWS.MINOR_NAME_CHANGE, true);
        next();
    });
    page("/flow" + ROUTES.NAME.MAJOR_NAME_CHANGE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.MAJOR_NAME_CHANGE,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.MAJOR_NAME_CHANGE,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.NAME.MAJOR_NAME_CHANGE, function (context, next) {
        closeModal(context, VIEWS.MAJOR_NAME_CHANGE, true);
        next();
    });
    page("/flow" + ROUTES.NAME.LEGAL_NAME_CHANGE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.LEGAL_NAME_CHANGE,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.LEGAL_NAME_CHANGE,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.NAME.LEGAL_NAME_CHANGE, function (context, next) {
        closeModal(context, VIEWS.LEGAL_NAME_CHANGE, true);
        next();
    });
    page("/flow" + ROUTES.NAME.MAIL_FILES_NAME_CHANGE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.MAIL_FILES_NAME_CHANGE,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.MAIL_FILES_NAME_CHANGE,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.NAME.MAIL_FILES_NAME_CHANGE, function (context, next) {
        closeModal(context, VIEWS.MAIL_FILES_NAME_CHANGE, true);
        next();
    });
    // Non-flow routes for name
    page(ROUTES.NAME.UPDATE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.UPDATE_NAME,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.UPDATE_NAME,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit(ROUTES.NAME.UPDATE, function (context, next) {
        closeModal(context, VIEWS.UPDATE_NAME, true);
        next();
    });
    page(ROUTES.NAME.UPDATE_SUCCESS, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.changeExit({
            enter: {
                overpanel: true,
                view: VIEWS.UPDATE_NAME_SUCCESS,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit(ROUTES.NAME.UPDATE_SUCCESS, function (context, next) {
        closeModal(context, VIEWS.UPDATE_NAME_SUCCESS, true);
        return next();
    });
    page(ROUTES.NAME.MINOR_NAME_CHANGE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.MINOR_NAME_CHANGE,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.MINOR_NAME_CHANGE,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit(ROUTES.NAME.MINOR_NAME_CHANGE, function (context, next) {
        closeModal(context, VIEWS.MINOR_NAME_CHANGE, true);
        next();
    });
    page(ROUTES.NAME.MAJOR_NAME_CHANGE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.MAJOR_NAME_CHANGE,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.MAJOR_NAME_CHANGE,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit(ROUTES.NAME.MAJOR_NAME_CHANGE, function (context, next) {
        closeModal(context, VIEWS.MAJOR_NAME_CHANGE, true);
        next();
    });
    page(ROUTES.NAME.LEGAL_NAME_CHANGE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.LEGAL_NAME_CHANGE,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.LEGAL_NAME_CHANGE,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit(ROUTES.NAME.LEGAL_NAME_CHANGE, function (context, next) {
        closeModal(context, VIEWS.LEGAL_NAME_CHANGE, true);
        next();
    });
    page(ROUTES.NAME.MAIL_FILES_NAME_CHANGE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.MAIL_FILES_NAME_CHANGE,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.MAIL_FILES_NAME_CHANGE,
                slide: 0,
                params: params,
                flow: FLOWS.NAME_PAGE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit(ROUTES.NAME.MAIL_FILES_NAME_CHANGE, function (context, next) {
        closeModal(context, VIEWS.MAIL_FILES_NAME_CHANGE, true);
        next();
    });
    page(ROUTES.PASSPORT.DELETE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.DELETE_PASSPORT,
                slide: 0,
                params: params,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.DELETE_PASSPORT,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    page.exit(ROUTES.PASSPORT.DELETE, function (context, next) {
        closeModal(context, VIEWS.DELETE_PASSPORT, true);
        return next();
    });
    page(ROUTES.PASSPORT.DELETE_SUCCESS, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.DELETE_PASSPORT_SUCCESS,
                slide: 0,
                params: params,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.DELETE_PASSPORT_SUCCESS,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    page.exit(ROUTES.PASSPORT.DELETE_SUCCESS, function (context, next) {
        closeModal(context, VIEWS.DELETE_PASSPORT_SUCCESS, true);
        return next();
    });
    page("/flow" + ROUTES.PASSPORT.DELETE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.DELETE_PASSPORT,
                slide: 0,
                params: params,
                flow: FLOWS.PASSPORT_PAGE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.DELETE_PASSPORT,
                slide: 0,
                params: params,
                flow: FLOWS.PASSPORT_PAGE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.PASSPORT.DELETE, function (context, next) {
        closeModal(context, VIEWS.DELETE_PASSPORT, true);
        return next();
    });
    page("/flow" + ROUTES.PASSPORT.DELETE_SUCCESS, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.DELETE_PASSPORT_SUCCESS,
                slide: 0,
                params: params,
                flow: FLOWS.PASSPORT_PAGE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.DELETE_PASSPORT_SUCCESS,
                slide: 0,
                params: params,
                flow: FLOWS.PASSPORT_PAGE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.PASSPORT.DELETE_SUCCESS, function (context, next) {
        closeModal(context, VIEWS.DELETE_PASSPORT_SUCCESS, true);
        return next();
    });
    page("/flow" + ROUTES.PASSPORT.UPDATE_SUCCESS, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.UPDATE_PASSPORT_SUCCESS,
                slide: 0,
                params: params,
                flow: FLOWS.PASSPORT_PAGE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.UPDATE_PASSPORT_SUCCESS,
                slide: 0,
                params: params,
                flow: FLOWS.PASSPORT_PAGE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.PASSPORT.UPDATE_SUCCESS, function (context, next) {
        closeModal(context, VIEWS.UPDATE_PASSPORT_SUCCESS, true);
        return next();
    });
    page("/flow" + ROUTES.PASSPORT.UPDATE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.UPDATE_PASSPORT,
                slide: 0,
                params: params,
                flow: FLOWS.PASSPORT_PAGE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.UPDATE_PASSPORT,
                slide: 0,
                params: params,
                flow: FLOWS.PASSPORT_PAGE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.PASSPORT.UPDATE, function (context, next) {
        closeModal(context, VIEWS.UPDATE_PASSPORT, true);
        next();
    });
    page(ROUTES.PASSPORT.UPDATE_SUCCESS, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.UPDATE_PASSPORT_SUCCESS,
                slide: 0,
                params: params,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.UPDATE_PASSPORT_SUCCESS,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    page.exit(ROUTES.PASSPORT.UPDATE_SUCCESS, function (context, next) {
        closeModal(context, VIEWS.UPDATE_PASSPORT_SUCCESS, true);
        return next();
    });
    // Extend User's Session
    page(ROUTES.EXTEND_SESSION, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.EXTEND_SESSION,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    page("/flow" + ROUTES.PHONES.MANAGE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.PHONES.MANAGE,
                slide: 0,
                params: params,
                flow: FLOWS.MANAGE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.PHONES.MANAGE,
                slide: 0,
                params: params,
                flow: FLOWS.MANAGE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.PHONES.MANAGE, function (context, next) {
        closeModal(context, VIEWS.PHONES.MANAGE, true);
        next();
    });
    page(ROUTES.PHONES.MANAGE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.PHONES.MANAGE,
                slide: 0,
                params: params,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.PHONES.MANAGE,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    page.exit(ROUTES.PHONES.MANAGE, function (context, next) {
        closeModal(context, VIEWS.PHONES.MANAGE, true);
        return next();
    });
    page("/flow" + ROUTES.PHONES.REMOVE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.PHONES.DELETE,
                slide: 0,
                params: params,
                flow: FLOWS.PHONE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.PHONES.DELETE,
                slide: 0,
                params: params,
                flow: FLOWS.PHONE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.PHONES.REMOVE, function (context, next) {
        closeModal(context, VIEWS.PHONES.DELETE, true);
        next();
    });
    page(ROUTES.PHONES.REMOVE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.PHONES.DELETE,
                slide: 0,
                params: params,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.PHONES.DELETE,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    page.exit(ROUTES.PHONES.REMOVE, function (context, next) {
        closeModal(context, VIEWS.PHONES.DELETE, true);
        return next();
    });
    page("/flow" + ROUTES.PHONES.MAKE_PRIMARY, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.PHONES.MAKE_PRIMARY,
                slide: 0,
                params: params,
                flow: FLOWS.PHONE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.PHONES.MAKE_PRIMARY,
                slide: 0,
                params: params,
                flow: FLOWS.PHONE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.PHONES.MAKE_PRIMARY, function (context, next) {
        closeModal(context, VIEWS.PHONES.MAKE_PRIMARY, true);
        next();
    });
    page(ROUTES.PHONES.MAKE_PRIMARY, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.PHONES.MAKE_PRIMARY,
                slide: 0,
                params: params,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.PHONES.MAKE_PRIMARY,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    page.exit(ROUTES.PHONES.MAKE_PRIMARY, function (context, next) {
        closeModal(context, VIEWS.PHONES.DELETE, true);
        return next();
    });
    page("/flow" + ROUTES.PHONES.ADD, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.changeExit({
            enter: {
                overpanel: true,
                view: VIEWS.PHONES.ADD,
                slide: 0,
                params: params,
                flow: FLOWS.PHONE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.PHONES.ADD,
                slide: 0,
                params: params,
                flow: FLOWS.PHONE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.PHONES.ADD, function (context, next) {
        closeModal(context, VIEWS.PHONES.ADD, true);
        next();
    });
    page(ROUTES.PHONES.ADD, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.changeExit({
            enter: {
                overpanel: true,
                view: VIEWS.PHONES.ADD,
                slide: 0,
                params: params,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.PHONES.ADD,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    page.exit(ROUTES.PHONES.ADD, function (context, next) {
        closeModal(context, VIEWS.PHONES.DELETE, true);
        return next();
    });
    page("/flow" + ROUTES.PHONES.EDIT, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.changeExit({
            enter: {
                overpanel: true,
                view: VIEWS.PHONES.UPDATE,
                slide: 0,
                params: params,
                flow: FLOWS.PHONE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.PHONES.UPDATE,
                slide: 0,
                params: params,
                flow: FLOWS.PHONE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.PHONES.EDIT, function (context, next) {
        closeModal(context, VIEWS.PHONES.UPDATE, true);
        next();
    });
    page(ROUTES.PHONES.EDIT, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.changeExit({
            enter: {
                overpanel: true,
                view: VIEWS.PHONES.UPDATE,
                slide: 0,
                params: params,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.PHONES.UPDATE,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    page.exit(ROUTES.PHONES.EDIT, function (context, next) {
        closeModal(context, VIEWS.PHONES.UPDATE, true);
        return next();
    });
    page("/flow" + ROUTES.PHONES.UPDATE_PPC, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.changeExit({
            enter: {
                overpanel: true,
                view: VIEWS.UPDATE_PPC,
                slide: 0,
                params: params,
                flow: FLOWS.PHONE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.PHONES.UPDATE_PPC, function (context, next) {
        closeModal(context, VIEWS.UPDATE_PPC, true);
        return next();
    });
    page(ROUTES.PHONES.UPDATE_PPC, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.changeExit({
            enter: {
                overpanel: true,
                view: VIEWS.UPDATE_PPC,
                slide: 0,
                params: params,
                flow: FLOWS.PHONE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit(ROUTES.PHONES.UPDATE_PPC, function (context, next) {
        closeModal(context, VIEWS.UPDATE_PPC, true);
        return next();
    });
    page("/flow" + ROUTES.PHONES.CHANGE_PRIMARY, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.PHONES.CHANGE_PRIMARY,
                slide: 0,
                params: params,
                flow: FLOWS.PHONE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.PHONES.CHANGE_PRIMARY,
                slide: 0,
                params: params,
                flow: FLOWS.PHONE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.PHONES.CHANGE_PRIMARY, function (context, next) {
        closeModal(context, VIEWS.PHONES.CHANGE_PRIMARY, true);
        next();
    });
    page(ROUTES.PHONES.CHANGE_PRIMARY, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.PHONES.CHANGE_PRIMARY,
                slide: 0,
                params: params,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.PHONES.CHANGE_PRIMARY,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    page.exit(ROUTES.PHONES.CHANGE_PRIMARY, function (context, next) {
        closeModal(context, VIEWS.PHONES.CHANGE_PRIMARY, true);
        return next();
    });
    page("/flow" + ROUTES.PHONES.VALIDATE_CONFIRMATION, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.changeExit({
            enter: {
                overpanel: true,
                view: VIEWS.PHONES.VALIDATE_CODE,
                slide: 0,
                params: params,
                flow: FLOWS.PHONE,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.PHONES.VALIDATE_CODE,
                slide: 0,
                params: params,
                flow: FLOWS.PHONE,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.PHONES.VALIDATE_CONFIRMATION, function (context, next) {
        closeModal(context, VIEWS.PHONES.VALIDATE_CODE, true);
        next();
    });
    page(ROUTES.PHONES.VALIDATE_CONFIRMATION, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.changeExit({
            enter: {
                overpanel: true,
                view: VIEWS.PHONES.VALIDATE_CODE,
                slide: 0,
                params: params,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.PHONES.VALIDATE_CODE,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    page.exit(ROUTES.PHONES.VALIDATE_CONFIRMATION, function (context, next) {
        closeModal(context, VIEWS.PHONES.VALIDATE_CODE, true);
        return next();
    });
    page("/flow" + ROUTES.ADDRESSES.MANAGE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.ADDRESSES.MANAGE,
                slide: 0,
                params: params,
                flow: FLOWS.ADDRESS,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.ADDRESSES.MANAGE,
                slide: 0,
                params: params,
                flow: FLOWS.ADDRESS,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.ADDRESSES.MANAGE, function (context, next) {
        closeModal(context, VIEWS.ADDRESSES.MANAGE, true);
        next();
    });
    page(ROUTES.ADDRESSES.MANAGE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.ADDRESSES.MANAGE,
                slide: 0,
                params: params,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.ADDRESSES.MANAGE,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    page.exit(ROUTES.ADDRESSES.MANAGE, function (context, next) {
        closeModal(context, VIEWS.ADDRESSES.MANAGE, true);
        return next();
    });
    page(ROUTES.ADDRESSES.MAKE_PRIMARY, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.ADDRESSES.MAKE_PRIMARY,
                slide: 0,
                params: params,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.ADDRESSES.MAKE_PRIMARY,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    page.exit(ROUTES.ADDRESSES.MAKE_PRIMARY, function (context, next) {
        closeModal(context, VIEWS.ADDRESSES.MAKE_PRIMARY, true);
        return next();
    });
    page("/flow" + ROUTES.ADDRESSES.MAKE_PRIMARY, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.ADDRESSES.MAKE_PRIMARY,
                slide: 0,
                params: params,
                flow: FLOWS.ADDRESS,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.ADDRESSES.MAKE_PRIMARY,
                slide: 0,
                params: params,
                flow: FLOWS.ADDRESS,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.ADDRESSES.MAKE_PRIMARY, function (context, next) {
        closeModal(context, VIEWS.ADDRESSES.MAKE_PRIMARY, true);
        next();
    });
    page("/flow" + ROUTES.ADDRESSES.ADD, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.ADDRESSES.ADD,
                slide: 0,
                params: params,
                flow: FLOWS.ADDRESS,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.ADDRESSES.ADD,
                slide: 0,
                params: params,
                flow: FLOWS.ADDRESS,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.ADDRESSES.ADD, function (context, next) {
        closeModal(context, VIEWS.ADDRESSES.ADD, true);
        next();
    });
    page(ROUTES.ADDRESSES.ADD, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.ADDRESSES.ADD,
                slide: 0,
                params: params,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.ADDRESSES.ADD,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    page.exit(ROUTES.ADDRESSES.ADD, function (context, next) {
        closeModal(context, VIEWS.ADDRESSES.ADD, true);
        return next();
    });
    page("/flow" + ROUTES.ADDRESSES.REMOVE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.ADDRESSES.DELETE,
                slide: 0,
                params: params,
                flow: FLOWS.ADDRESS,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.ADDRESSES.DELETE,
                slide: 0,
                params: params,
                flow: FLOWS.ADDRESS,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.ADDRESSES.REMOVE, function (context, next) {
        closeModal(context, VIEWS.ADDRESSES.DELETE, true);
        next();
    });
    page(ROUTES.ADDRESSES.REMOVE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.ADDRESSES.DELETE,
                slide: 0,
                params: params,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.ADDRESSES.DELETE,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    page.exit(ROUTES.ADDRESSES.REMOVE, function (context, next) {
        closeModal(context, VIEWS.ADDRESSES.DELETE, true);
        return next();
    });
    page("/flow" + ROUTES.ADDRESSES.EDIT, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.ADDRESSES.UPDATE,
                slide: 0,
                params: params,
                flow: FLOWS.ADDRESS,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.ADDRESSES.UPDATE,
                slide: 0,
                params: params,
                flow: FLOWS.ADDRESS,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.ADDRESSES.EDIT, function (context, next) {
        closeModal(context, VIEWS.ADDRESSES.UPDATE, true);
        next();
    });
    page(ROUTES.ADDRESSES.EDIT, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.ADDRESSES.UPDATE,
                slide: 0,
                params: params,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.ADDRESSES.UPDATE,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    page.exit(ROUTES.ADDRESSES.EDIT, function (context, next) {
        closeModal(context, VIEWS.ADDRESSES.UPDATE, true);
        return next();
    });
    page("/flow" + ROUTES.ADDRESSES.EDIT_PPC, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.ADDRESSES.EDIT_PPC,
                slide: 0,
                params: params,
                flow: FLOWS.ADDRESS,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.ADDRESSES.EDIT_PPC,
                slide: 0,
                params: params,
                flow: FLOWS.ADDRESS,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.ADDRESSES.EDIT_PPC, function (context, next) {
        closeModal(context, VIEWS.ADDRESSES.EDIT_PPC, true);
        next();
    });
    page(ROUTES.ADDRESSES.EDIT_PPC, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.ADDRESSES.EDIT_PPC,
                slide: 0,
                params: params,
                query: query,
            },
            exit: {
                overpanel: false,
                view: VIEWS.ADDRESSES.EDIT_PPC,
                slide: 0,
                params: params,
                query: query,
            },
        }));
    });
    page.exit(ROUTES.ADDRESSES.EDIT_PPC, function (context, next) {
        closeModal(context, VIEWS.ADDRESSES.EDIT_PPC, true);
        return next();
    });
    page("/flow" + ROUTES.OCCUPATION.GET, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.UPDATE_OCCUPATION,
                slide: 0,
                params: params,
                flow: FLOWS.OCCUPATION,
                query: query,
            },
            isFlow: true,
        }));
    });
    page.exit("/flow" + ROUTES.OCCUPATION.GET, function (context, next) {
        closeModal(context, VIEWS.UPDATE_OCCUPATION, true);
        next();
    });
    page.start();
}
exports.default = initRoutes;
